// extracted by mini-css-extract-plugin
export default {"radio":"styles_radio__I0oLe","selected":"styles_selected__Iehw9","tag":"styles_tag__Ih72k"};